import { ApiCall } from '@lcms/api-definition';
import { endpoints } from '../../endpoints';

export type EndpointResponse = any

export const profileEndpoint = new ApiCall<EndpointResponse>().get('profile', { route: endpoints.profile });